import {
  WAITING_FOR_MANAGER_KEY,
} from "./usageStatusChartHelpers";

export type UsageTableFilterChipLink = "managers" | "breakdown";

/** Waiting-for-manager is the only status that forks between people and managers. */
export const shouldShowWaitingForManagerPopover = (
  segmentId: string,
): boolean => segmentId === WAITING_FOR_MANAGER_KEY;

export const getUsageTableFilterChipLink = (
  statusKey: string | null | undefined,
): UsageTableFilterChipLink =>
  statusKey === WAITING_FOR_MANAGER_KEY ? "managers" : "breakdown";

export const buildStatusDrilldownParams = (
  displayLabel: string,
  outerDrilldownValue?: string,
) => [
  { key: "drilldownValue", value: displayLabel },
  { key: "drilldownType", value: "EXACT" },
  { key: "outerDrilldownValue", value: outerDrilldownValue ?? "" },
];

export { WAITING_FOR_MANAGER_KEY };
